import { defineAsyncComponent } from "vue";

const Icon = defineAsyncComponent(() =>
    import("./components/Icon.vue" /* webpackChunkName: "icon" */)
);

const Finder = defineAsyncComponent(() =>
    import("./components/Finder" /* webpackChunkName: "finder" */)
);

const Slider = defineAsyncComponent(() =>
    import("./components/Slider.vue" /* webpackChunkName: "slider" */)
);

const CasesMap = defineAsyncComponent(() =>
    import("./components/CasesMap.vue" /* webpackChunkName: "cases-map" */)
);

const HeaderSlider = defineAsyncComponent(() =>
    import(
        "./components/HeaderSlider.vue" /* webpackChunkName: "header-slider" */
    )
);

const MaterialOffers = defineAsyncComponent(() =>
    import(
        "./components/MaterialOffers.vue" /* webpackChunkName: "material-offers" */
    )
);

const MainMenuSlider = defineAsyncComponent(() =>
    import(
        "./components/MainMenuSlider.vue" /* webpackChunkName: "main-menu-slider" */
    )
);

const CasesPageContent = defineAsyncComponent(() =>
    import(
        "./components/CasesPageContent.vue" /* webpackChunkName: "cases-page-content" */
    )
);

const RegionPresentor = defineAsyncComponent(() =>
    import(
        "./components/RegionPresentor.vue" /* webpackChunkName: "region-presentor" */
    )
);

const RegionChanger = defineAsyncComponent(() =>
    import(
        "./components/RegionChanger" /* webpackChunkName: "region-changer" */
    )
);

const PopupForm = defineAsyncComponent(() =>
    import("./components/PopupForm" /* webpackChunkName: "popup-form" */)
);

const Seo = defineAsyncComponent(() =>
    import("./components/Seo.vue" /* webpackChunkName: "seo" */)
);

export {
    Icon,
    Finder,
    Slider,
    CasesMap,
    HeaderSlider,
    RegionChanger,
    MainMenuSlider,
    MaterialOffers,
    RegionPresentor,
    CasesPageContent,
    PopupForm,
    Seo,
};
